import { ETrueFalse } from 'enums/trueFalse';

const trueFalseSelect = [
    {
        value: ETrueFalse.TRUE,
        labelcz: 'ANO'
        // labelen: 'ANO'
    },
    {
        value: ETrueFalse.FALSE,
        labelcz: 'NE'
        // labelen: 'NE'
    }
];

export default trueFalseSelect;
